module.exports = ".full-width{cursor:zoom-in;width:100%}\n"